import { render, staticRenderFns } from "./IllnessConnection.vue?vue&type=template&id=6fde6d6e&"
import script from "./IllnessConnection.vue?vue&type=script&lang=js&"
export * from "./IllnessConnection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports